import React, { useState, useEffect } from "react";
import { BulletIcon } from "../../components/Icons";
import { Button, Form, InputGroup, Col, Row } from "react-bootstrap";
import { applyPromoCode, checkPromoCode } from "../../services/auth.service";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginr, selectUser } from "../../slice/authSlice";
import SubscriptionSuccessModal from "../../modals/successModal/SubscriptionSuccessModal";
import { encryptData } from "../../utils/encryptDecrypt";
import { toast } from "react-toastify";
import * as cardValidator from "card-validator";
import SubPaymentModal from "../../modals/subPayment/subPayment";

const SubscriptionPlan = ({ plan }) => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const user = useSelector(selectUser);
  const [promoCode, setPromoCode] = useState("");
  const [isApplied, setApplied] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [subPaymentModal, setSubPaymentModal] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  // const [cardExpirationDate, setCardExpirationDate] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [cardMonth, setCardMonth] = useState("");
  const [cardYear, setCardYear] = useState("");
  const [cvv, setCvv] = useState();
  const [errors, setErrors] = useState({
    cardNumber: "",
    cardYear: "",
    cardCvv: "",
  });

  const handleCardNumber = (value) => {
    //console.log("value", value)
    value = value.replace(/\s/g, ""); // Remove existing spaces
    value = value.replace(/-/g, ""); // Remove existing dashes

    // Add space or dash after every four digits
    value = value.replace(/(\d{4})(?=\d)/g, "$1 ");

    // Trim extra characters if the length exceeds 23 digits (including spaces)
    value = value.slice(0, 23);
    setCardNumber(value);
  };

  const checkCard = () => {
    let valid = true;
    const cardNumberValidation = cardValidator.number(cardNumber);
    const expiryDateValidation = cardValidator.expirationDate({
      month: cardMonth,
      year: cardYear,
    });
    const cvvValidation = cardValidator.cvv(cvv);
    let newErros = { ...errors };
    if (!cardNumberValidation.isValid) {
      // alert('Invalid Card Number');
      valid = false;
      newErros.cardNumber = "Invalid card number";
      // return;
    } else {
      newErros.cardNumber = "";
    }

    if (!expiryDateValidation.isValid) {
      valid = false;
      newErros.cardYear = "Invalid card expiry date";
      // return;
    } else {
      newErros.cardYear = "";
    }

    if (!cvvValidation.isValid) {
      valid = false;
      newErros.cardCvv = "Invalid card number";
      // return;
    } else {
      newErros.cardCvv = "";
    }
    setErrors(newErros);
    return valid;
  };

  const fetchDescription = (des) => {
    if (des) {
      const items = des.split(", ");
      return (
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              <i>
                <BulletIcon />
              </i>{" "}
              {item}
            </li>
          ))}
        </ul>
      );
    } else return "";
  };

  const fetchPrice = (price) => {
    if (isApplied) {
      return (
        <>
          <p className="text-decoration-line-through d-inline-block">{price}</p>{" "}
          $<p className="d-inline-block">{discountedPrice}</p>
          <span>/m</span>
        </>
      );
    } else {
      return (
        <>
          $<p className="d-inline-block">{price}</p>
          <span>/m</span>
        </>
      );
    }
  };

  const handleVerifyCode = async (planId) => {
    await dispatch(setLoader(true));
    try {
      let payload = {
        planId: planId,
        promoCode: promoCode,
      };
      const response = await checkPromoCode(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setApplied(true);
        setDiscountedPrice(response?.data?.discountPrice);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleClose = () => {
    setSubPaymentModal(false)
  }

  const handleApplyCode = async () => {
    if (checkCard()) {
      await dispatch(setLoader(true));
      try {
        let payload = {
          promoCode: promoCode,
          cardNumber: encryptData(cardNumber.replace(/\s/g, "")),
          cardExpirationDate: encryptData(cardMonth + cardYear),
          cvv: encryptData(cvv),
        };
        const response = await applyPromoCode(payload);
        await dispatch(setLoader(false));
        if (response?.data?.status) {
          if (response.data?.isSubscribed) {
            setCardMonth("");
            setCardNumber("");
            setCardYear("");
            setCvv("");
            let modifiedUserData = {
              ...user,
              isSubscribed: true,
            };
            toast.success(response?.data?.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            setSubPaymentModal(false)
            setSuccessModal(true);
            await dispatch(loginr(modifiedUserData));
          } else {
            toast.error(response?.data?.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        }
      } catch (error) {
        await dispatch(setLoader(false));
        console.error("Error fetching data:", error);
      }
    }
  };

  return (
    <div className="price-table h-100">
      <div className="price-table-header">
        <div className="price-table-title">{plan?.name}</div>
        <div className="price-wrap">{fetchPrice(plan?.price)}</div>
      </div>
      <div className="plan-wrapper">
        <h5 className="plan-title">This plan Includes:</h5>
        {fetchDescription(plan?.description)}
      </div>
      <div className="apply-wrapper">
        <div className="apply">
          <InputGroup>
            <Form.Control
              onChange={(e) => setPromoCode(e.target.value)}
              placeholder="Apply Promo Code"
            />
            <Button
              disabled={!promoCode}
              onClick={() => handleVerifyCode(plan?._id)}
              variant="primary"
              id="button-addon2"
            >
              Apply
            </Button>
            {/* <div className="add-new-card-form" style={{ marginTop: "20px" }}>
              <div className="add-new-card w-100">
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label>Card Number</Form.Label>
                    <Form.Control
                      type="text"
                      value={cardNumber}
                      placeholder="Enter Card Number"
                      onChange={(e) => handleCardNumber(e.target.value)}
                    />
                    <div className="payment-error">{errors?.cardNumber ? errors.cardNumber : null}</div>
                  </Col>
                  <Col md={4}>
                    <Form.Label>Expiry Month</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      value={cardMonth}
                      onChange={(e) => setCardMonth(e.target.value)}
                    >
                      <option>Select Month</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </Form.Select>
                  </Col>
                  <Col md={4}>
                    <Form.Label>Expiry Year</Form.Label>
                    <Form.Control
                      type="text"
                      value={cardYear}
                      placeholder="Enter Expiry Year"
                      onChange={(e) => setCardYear(e.target.value)}
                    />
                    <div className="payment-error">{errors?.cardYear ? errors.cardYear : null}</div>
                  </Col>
                  <Col md={4}>
                    <Form.Label>CVV</Form.Label>
                    <Form.Control
                      type="text"
                      value={cvv}
                      placeholder="Enter CVV"
                      onChange={(e) => setCvv(e.target.value)}
                    />
                    <div className="payment-error">{errors?.cardCvv ? errors.cardCvv : null}</div>
                  </Col>
                </Row>
              </div>
            </div> */}
          </InputGroup>
        </div>
        <div className="w-100 d-grid pay-wrap">
          <Button
            variant="outline-primary"
            disabled={!isApplied}
            // onClick={() => handleApplyCode()}
            onClick={() => setSubPaymentModal(true)}
          >
            Pay Now
          </Button>
        </div>
      </div>
      <SubscriptionSuccessModal successModal={successModal} />
      <SubPaymentModal
        subPaymentModal={subPaymentModal}
        handleCardNumber={handleCardNumber}
        setCardYear={setCardYear}
        cardNumber={cardNumber}
        cardYear={cardYear}
        setCardMonth={setCardMonth}
        cardMonth={cardMonth}
        setCvv={setCvv}
        cvv={cvv}
        errors={errors}
        handleApplyCode={handleApplyCode}
        handleClose={handleClose}
      />
    </div>
  );
};

export default SubscriptionPlan;
